import { render, staticRenderFns } from "./ChangeOfferGoodsForm.vue?vue&type=template&id=7f7162a0"
import script from "./ChangeOfferGoodsForm.vue?vue&type=script&lang=js"
export * from "./ChangeOfferGoodsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports